import { render, staticRenderFns } from "./ContentEditColor.vue?vue&type=template&id=71daa08b&"
import script from "./ContentEditColor.vue?vue&type=script&lang=js&"
export * from "./ContentEditColor.vue?vue&type=script&lang=js&"
import style0 from "./ContentEditColor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VColorPicker } from 'vuetify/lib/components/VColorPicker';
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VBtn,VColorPicker,VDivider})
